import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function LoginPage({ mode, onAuth }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;

    if (mode === "setup" && password !== confirmPassword) {
      toast.error("Passwoerter stimmen nicht ueberein");
      return;
    }
    if (mode === "setup" && password.length < 4) {
      toast.error("Mindestens 4 Zeichen");
      return;
    }

    setLoading(true);
    try {
      const endpoint = mode === "setup" ? "/auth/setup" : "/auth/login";
      const res = await api.post(endpoint, { password });
      onAuth(res.data.token);
    } catch (err) {
      toast.error(
        err.response?.status === 401
          ? "Falsches Passwort"
          : err.response?.data?.detail || "Fehler"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-background flex flex-col items-center justify-center p-4"
      data-testid="login-page"
    >
      <div className="w-full max-w-xs space-y-8">
        <div className="text-center">
          <h1 className="font-heading text-4xl font-bold text-white tracking-tight">
            100K
          </h1>
          <p className="text-zinc-600 text-xs uppercase tracking-[0.3em] mt-2">
            Punktesystem 2026
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-600" />
            <Input
              type="password"
              placeholder={mode === "setup" ? "Passwort festlegen" : "Passwort"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pl-10 bg-zinc-950/50 border-zinc-800 h-12 text-sm"
              autoFocus
              data-testid="password-input"
            />
          </div>

          {mode === "setup" && (
            <Input
              type="password"
              placeholder="Passwort bestaetigen"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="bg-zinc-950/50 border-zinc-800 h-12 text-sm"
              data-testid="confirm-password-input"
            />
          )}

          <Button
            type="submit"
            className="w-full h-12 bg-white text-black hover:bg-zinc-200 font-medium"
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading
              ? "..."
              : mode === "setup"
              ? "Passwort festlegen"
              : "Anmelden"}
          </Button>
        </form>

        {mode === "setup" && (
          <p className="text-zinc-700 text-xs text-center">
            Waehle ein Passwort fuer den Zugang zu deinem Punktesystem.
          </p>
        )}
      </div>
    </div>
  );
}
